import { Header, Text } from '@rbilabs/universal-components';
import { Image, StyleSheet, View } from 'react-native';

import ActionButtonLink from 'components/action-button';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

const crownImage = require('./gray-crown.png');

export const LoyaltyRewardsEmptyScreen = () => {
  return (
    <View style={styles.wrapper}>
      <Image style={styles.image} source={crownImage} />
      <Header variant="headerOne" marginBottom="4">
        {t('rewardNotAvailable', 'Reward Not Available')}
      </Header>
      <Text variant="copyOne" textAlign="center" marginBottom="8">
        {t(
          'rewardNotAvailableDescription',
          `Rewards aren't available at your current location, but we're working to bring them to more places soon.`
        )}
      </Text>
      <ActionButtonLink to={routes.menu}>
        {t('browseMenuInstead', 'Browse Menu Instead')}
      </ActionButtonLink>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    alignItems: 'center',
    padding: 32,
  },
  image: {
    width: 173,
    height: 173,
  },
});
